<template>
  <div class="content ht-100v pd-0">
    <div class="content-header" slot="content-header">
      Мэдэгдэл илгээх
    </div>
    <div class="content-body pd-0">
      <div class="container pd-x-0 mg-b-0">
        <div class="card mg-t-20">
          <div
            class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-10"
          >
            <div>
              <h6 class="mg-b-5">Илгээсэн мэдэгдлүүд</h6>
              <p class="tx-13 tx-color-03 mg-b-0">тайлбар</p>
            </div>
            <div class="d-flex">
              <div class="btn-group flex-fill">
                <button
                  @click="createSignal()"
                  class="btn btn-white btn-xs"
                  :class="{ active: seenFlag == null }"
                >
                  Шинэ
                </button>
                <!-- <button @click="pager.current=1; seenFlag=true; init();" class="btn btn-white btn-xs" :class="{'active': seenFlag==true }">Үзсэн</button>
                <button @click="pager.current=1; seenFlag=false; init();" class="btn btn-white btn-xs" :class="{'active': seenFlag==false }">Үзээгүй</button> -->
              </div>
            </div>
          </div>
          <!-- card-header -->
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Гарчиг</th>
                <th scope="col">Огноо</th>
                <th scope="col">Percent</th>
              </tr>
            </thead>
            <tbody>
              <tr
                @click="showDetail(t)"
                role="button"
                v-for="(t, i) in tasks"
                :key="i"
                :class="{ 'bg-light': t.im != null && !t.im.seen }"
              >
                <th scope="row" class="text-muted">
                  {{ (pager.current - 1) * pager.perPage + i + 1 }}
                </th>
                <td class="wd-40p">
                  <div class="">{{ t.task }}</div>
                </td>
                <td class="text-muted text-nowrap">
                  <!-- {{t.dueStartDate | moment('YYYY.MM.DD HH:mm')}} -->
                </td>
              </tr>
            </tbody>
          </table>
          <div class="card-footer text-center">
            <b-pagination
              v-show="tasksCount > 0"
              size="sm"
              align="center"
              v-model="pager.current"
              :total-rows="tasksCount"
              :per-page="pager.perPage"
              @change="pageChanged"
              style="margin-bottom: 0"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <task-detail-side
      v-if="taskDialog.id > 0"
      :id.sync="taskDialog.id"
      @on-task-detail="showDetail"
      @on-task-close="
        taskDialog.id = 0;
        taskLoaded();
      "
    ></task-detail-side>

    <b-modal
      v-model="signalr.modal"
      title="Шинэ мэдэгдэл"
      hide-footer
      size="lg"
      centered
      scrollable
    >
      <div>
        <div class="form-group">
          <label class="d-block">Мессеж</label>
          <textarea
            v-model="signalr.notification.msg"
            type="text"
            class="form-control"
            placeholder="Илгээх агуулга бичнэ үү"
            rows="4"
          ></textarea>
        </div>
        <div class="form-group">
          <label class="d-block">Тохиргоо</label>
          <Select v-model="signalr.sendMethod">
            <Option :value="1">Сонгосон хэрэглэгчид</Option>
            <Option :value="2">Байгууллагын бүх хэрэглэгчид</Option>
            <Option :value="999">Системийн бүр хэрэглэгчид</Option>
          </Select>
        </div>
        <div class="form-group">
          <label class="d-block">Харагдаж</label>
          <Select v-model="signalr.notification.type">
            <Option :value="1">Жижиг цонхонд мессеж хариуулах</Option>
            <Option :value="2">Тухайн хуудас дээрээ refresh хийх</Option>
            <Option :value="3">Заасан холбоосруу үсрэх</Option>
            <Option :value="999">Системээс гаргах</Option>
          </Select>
        </div>
        <div class="form-group">
          <label class="d-block">Хугацаа</label>
          <input
            v-model="signalr.notification.timeout"
            type="text"
            class="form-control"
            placeholder=""
          />
        </div>
        <div class="form-group">
          <label class="d-block">Холбоос</label>
          <input
            v-model="signalr.notification.link"
            type="text"
            class="form-control"
            placeholder=""
          />
        </div>
        <button @click="sendSignal()" class="btn btn-primary" type="submit">
          Илгээх
        </button>
        <button
          @click="signalr.modal = false"
          class="btn btn-secondary"
          type="cancel"
        >
          Болих
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { Select, Option } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

export default {
  components: {
    Select,
    Option,
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  mounted() {
    //this.featherReplace();
    //this.init();
  },
  // updated(){
  //   this.featherReplace();
  // },
  data() {
    return {
      tasks: [],
      tasksCount: 0,
      pager: {
        perPage: 15,
        current: 1
      },
      taskDialog: {
        show: false,
        id: 0,
        key: 0
      },
      seenFlag: null,

      signalr: {
        modal: false,
        sendMethod: 2,
        groupId: null,
        userId: null,
        taskId: null,
        notification: {
          type: 3,
          timeout: 5,
          msg: "",
          link: ""
        }
        //sendMethod: 1 bol zovhon tuhailsan hereglegchid, 2 bol tuhain baiguullagiin buh hereglegchid, 999 bol systemiin buh hereglegch gehde tuhain core deer bga client-uudiin huvid hamaaraltai,
        //send method 3 bol task iin oroltsogchid ruu
        //notification.type: 1 bol zovhon modal deer msg haragdah, 2 tuhain baigaa huudas deere refresh hiih, 3 bol zaasan link ruu usreh, 999 bol systemees garah buyu signout uildliin functiong duudah
      }
    };
  },
  methods: {
    ...mapActions(["handleLoading"]),
    init() {
      // request({
      //   api: { method: "post", url: "task/getPinnedTaskList" },
      //   data:{
      //     page: this.pager.current-1,
      //     size: this.pager.perPage,
      //     seen: this.seenFlag,
      //   },
      //   store: this.$store
      // }).then(res => {
      //   if (res != false) {
      //     this.tasks= res.data.tasks;
      //     if(this.seenFlag==null || this.seenFlag)
      //       this.tasksCount= res.data.count;
      //     else if(this.seenFlag==false)
      //       this.tasksCount= res.data.unseenCount;
      //     //console.log(res);
      //   }
      // });
    },
    createSignal() {
      this.signalr.modal = true;
    },
    sendSignal() {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "post", url: "SystemConfig/SendGlobalNotification" },
        data: this.signalr,
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.signalr.modal = false;
          //console.log('SendGlobalNotification', res);
        }
      });
    },
    pageChanged(e) {
      this.pager.current = e;
      this.init();
    },
    showDetail(e) {
      this.handleLoading({ isLoading: true });
      this.taskDialog.id = e.id;
    }
  }
};
</script>

<style></style>
